import { render, staticRenderFns } from "./programme2.html?vue&type=template&id=568139f4&lang=html&external"
import script from "./programme2.js?vue&type=script&lang=js&external"
export * from "./programme2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports